export const SET_INGREDIENT_REPLACEMENT_MODAL_STATE =
  "SET_INGREDIENT_REPLACEMENT_MODAL_STATE";
export const SET_INGREDIENT_REPLACEMENT_STEP =
  "SET_INGREDIENT_REPLACEMENT_STEP";
export const EDITABLE_INGREDIENT_REPLACEMENT_ROW = 'EDITABLE_INGREDIENT_REPLACEMENT_ROW';

export const setIngredientReplacementModalState = (isOpen) => {
  return {
    type: SET_INGREDIENT_REPLACEMENT_MODAL_STATE,
    payload: {
      isOpen,
    },
  };
};

export const setIngredientReplacementStep = (step) => ({
  type: SET_INGREDIENT_REPLACEMENT_STEP,
  payload: { step },
});

export const editIngredientReplacementRow = (editableIngredientReplacementRowId, editableIngredientReplacementItem) => {
  return {
    type: EDITABLE_INGREDIENT_REPLACEMENT_ROW,
    payload: {
      editableIngredientReplacementRowId,
      editableIngredientReplacementItem,
    },
  };
}
